<ng-container *ngFor="let d of dialogService.dialogs$ | async; trackBy: trackById">
	<dialog
		#nativeDialog
		class="qe-dialog {{d.panelClass || ''}}"
		role="dialog"
		aria-modal="true"
		(click)="onDialogClick($event, d.ref)"
		(cancel)="onCancel(d.ref, $event)"
	>
		<div
			class="qe-dialog__panel"
			[style.width]="d.width"
		>
			<button
				*ngIf="d.showClose"
				type="button"
				class="qe-modal__close"
				(click)="d.ref.close()"
				aria-label="Close dialog"
				data-quat="button_close_modal"
			>
				<svg class="qe-modal__close-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0_6866_11579)">
						<path d="M13.6934 0.70678L0.707351 13.6928C0.316827 14.0833 0.316827 14.7165 0.707351 15.107L0.89332 15.293C1.28384 15.6835 1.91701 15.6835 2.30753 15.293L15.2935 2.30696C15.6841 1.91644 15.6841 1.28327 15.2935 0.892749L15.1076 0.70678C14.7171 0.316256 14.0839 0.316256 13.6934 0.70678Z" fill="currentColor"/>
						<path d="M15.293 13.6931L2.30696 0.707107C1.91644 0.316582 1.28327 0.316582 0.892747 0.707107L0.706778 0.893076C0.316253 1.2836 0.316253 1.91677 0.706778 2.30729L13.6928 15.2933C14.0833 15.6838 14.7165 15.6838 15.107 15.2933L15.293 15.1073C15.6835 14.7168 15.6835 14.0836 15.293 13.6931Z" fill="currentColor"/>
					</g>
					<defs>
						<clipPath id="clip0_6866_11579">
							<rect width="16.001" height="16.0007" fill="white" transform="translate(-0.000244141 -0.000488281)"/>
						</clipPath>
					</defs>
				</svg>
			</button>
			<ng-container *ngComponentOutlet="d.component; injector: d.injector"></ng-container>
		</div>
		<div class="qe-dialog__scrolllock"></div>
	</dialog>
</ng-container>
